import { ReactElement } from "react";
import styled from "styled-components";
import { ElementProps } from "../../functionalComponents/RenderPage";

const StyledGridEnd = styled.div``;

const GridEnd = function(): ReactElement<ElementProps> {
  return <StyledGridEnd className="page-divider"></StyledGridEnd>;
};

export default GridEnd;
